import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, withKeys as _withKeys, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-50cc3246"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex" }
const _hoisted_2 = { class: "flex items-center px-3 py-1 text-md" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"min-width":"2.2rem"} }, "경고", -1))
const _hoisted_4 = { class: "flex items-center px-3 py-1 text-md" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"min-width":"2.2rem"} }, "주의", -1))
const _hoisted_6 = { class: "flex items-center px-3 py-1 text-md" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"min-width":"2.2rem"} }, "경고", -1))
const _hoisted_8 = { class: "flex items-center px-3 py-1 text-md" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"min-width":"2.2rem"} }, "주의", -1))
const _hoisted_10 = {
  class: "kfo2-col-process",
  style: {"min-width":"10rem","max-width":"10rem"}
}
const _hoisted_11 = { class: "flex" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fi fi-br-menu-dots-vertical" }, null, -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = {
  class: "cs-form cs-form-noline",
  "data-height": "xs"
}
const _hoisted_15 = { class: "" }
const _hoisted_16 = {
  class: "kfo2-col-material",
  style: {"min-width":"12rem","max-width":"12rem"}
}
const _hoisted_17 = { class: "flex" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fi fi-br-menu-dots-vertical" }, null, -1))
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = {
  class: "cs-form cs-form-noline",
  "data-height": "xs"
}
const _hoisted_22 = ["onUpdate:modelValue"]
const _hoisted_23 = { class: "" }
const _hoisted_24 = {
  class: "kfo2-col-company",
  style: {"min-width":"13rem"}
}
const _hoisted_25 = { class: "flex" }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fi fi-br-menu-dots-vertical" }, null, -1))
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = {
  class: "cs-form cs-form-noline",
  "data-height": "xs"
}
const _hoisted_30 = ["onUpdate:modelValue"]
const _hoisted_31 = {
  class: "kfo2-col-company",
  style: {"min-width":"15rem"}
}
const _hoisted_32 = {
  class: "cs-form cs-form-noline",
  "data-height": "xs"
}
const _hoisted_33 = ["onUpdate:modelValue"]
const _hoisted_34 = {
  class: "kfo2-col-company flex",
  style: {"min-width":"16.5rem"}
}
const _hoisted_35 = {
  class: "cs-form cs-form-noline mr-2",
  "data-height": "xs"
}
const _hoisted_36 = ["onUpdate:modelValue", "onInput", "onBlur"]
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "m-auto" }, "x", -1))
const _hoisted_38 = {
  class: "cs-form cs-form-noline ml-2 mr-2",
  "data-height": "xs"
}
const _hoisted_39 = ["onUpdate:modelValue", "onInput", "onBlur"]
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "m-auto" }, "x", -1))
const _hoisted_41 = {
  class: "cs-form cs-form-noline ml-2",
  "data-height": "xs"
}
const _hoisted_42 = ["onUpdate:modelValue", "onInput", "onBlur"]
const _hoisted_43 = {
  class: "kfo2-col-company flex items-center justify-center",
  style: {"min-width":"5rem","max-width":"5rem"}
}
const _hoisted_44 = ["checked", "onUpdate:modelValue"]
const _hoisted_45 = {
  class: "kfo2-col-company flex items-center justify-center",
  style: {"min-width":"5rem","max-width":"5rem"}
}
const _hoisted_46 = ["checked", "onUpdate:modelValue"]
const _hoisted_47 = {
  class: "kfo2-col-company",
  style: {"min-width":"6rem"}
}
const _hoisted_48 = {
  class: "cs-form cs-form-noline",
  "data-height": "xs"
}
const _hoisted_49 = ["onUpdate:modelValue", "onInput", "onBlur"]
const _hoisted_50 = {
  class: "kfo2-col-company",
  style: {"min-width":"9rem"}
}
const _hoisted_51 = {
  class: "cs-form cs-form-noline",
  "data-height": "xs"
}
const _hoisted_52 = ["onUpdate:modelValue", "onKeyup", "onBlur"]
const _hoisted_53 = {
  class: "kfo2-col-company",
  style: {"min-width":"9rem"}
}
const _hoisted_54 = {
  class: "cs-form cs-form-noline",
  "data-height": "xs"
}
const _hoisted_55 = ["onUpdate:modelValue", "onKeyup", "onBlur"]
const _hoisted_56 = {
  class: "kfo2-col-company",
  style: {"min-width":"9rem","border-width":"0px"}
}
const _hoisted_57 = {
  class: "cs-form cs-form-noline",
  "data-height": "xs"
}
const _hoisted_58 = ["onUpdate:modelValue", "onKeyup", "onBlur"]
const _hoisted_59 = { class: "flex" }
const _hoisted_60 = {
  class: "kfo2-col-company",
  style: {"min-width":"13rem","max-width":"12rem"}
}
const _hoisted_61 = {
  class: "cs-form",
  "data-height": "xs"
}
const _hoisted_62 = ["onUpdate:modelValue", "onKeypress"]
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"min-width":"67rem"} }, null, -1))
const _hoisted_64 = { class: "flex border-b border-line2" }
const _hoisted_65 = {
  class: "kfo2-col-material",
  style: {"min-width":"12rem","max-width":"12rem"}
}
const _hoisted_66 = {
  class: "cs-form",
  "data-height": "xs"
}
const _hoisted_67 = ["onKeypress"]
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"min-width":"79rem"} }, null, -1))

import {ref, computed, onMounted, PropType} from "vue";
import {storeToRefs} from "pinia";
import {toast} from "vue3-toastify";

import {numberToComma, dateConvertYMDHM_KR, removeComma} from "../../js/utils";
import {Process, Material, Company} from "../../js/interface";

import {CompanyStore} from "../../store/company-store";


/******************************************
 * 하이쓰리디 - 설정의 재료 및 협력사 리스트 행
 ******************************************/

import {defineComponent} from "vue";

const __default__ = defineComponent({
  name: "ProcessItem",
  methods: {},
});

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  process: {type: Object as PropType<Process>, required: true},
},
  setup(__props) {

const props = __props;



let processName = ref(props.process.name);
let processThickWarn = ref("" + props.process.thicknessWarn);
let procesThickCaution = ref("" + props.process.thicknessCaution);
let processGapWarn = ref("" + props.process.gapWarn);
let processGapCaution = ref("" + props.process.gapCaution);
let materialName = ref("");

let currentMaterial: null | Material = null;
let currentCompany: null | Company = null;

let isShowContextProcess = ref(false);
let isShowContextMaterial = ref(false);
let isShowContextCompany = ref(false);
const optionsContext = ref({
  clickClose: true,
  zIndex: 3,
  minWidth: 130,
  x: 500,
  y: 200,
  onClose: () => {
    isShowContextProcess.value = false;
    isShowContextMaterial.value = false;
    isShowContextCompany.value = false;
  },
});

const companyStore = CompanyStore();

const onChange = () => {
  CompanyStore().updateProcess({
    id: props.process.id,
    name: processName.value,
    thickWarn: processThickWarn.value,
    thickCaution: procesThickCaution.value,
    gapWarn: processGapWarn.value,
    gapCaution: processGapCaution.value,
  });
};

const onInputTickWarn = (value: any) => {
  const regExp = /^\d{0,1}(\.\d{0,2})?$/;
  if (!regExp.test(value)) {
    processThickWarn.value = value.substring(0, value.length - 1);
  }
  if (!value.length) {
    processThickWarn.value = processThickWarn.value.replace(/(^0+)/, "");
  }
};
const onInputTickCaution = (value: any) => {
  const regExp = /^\d{0,1}(\.\d{0,2})?$/;
  if (!regExp.test(value)) {
    procesThickCaution.value = value.substring(0, value.length - 1);
  }
  if (!value.length) {
    procesThickCaution.value = procesThickCaution.value.replace(/(^0+)/, "");
  }
};
const onInputGapWarn = (value: any) => {
  const regExp = /^\d{0,1}(\.\d{0,2})?$/;
  if (!regExp.test(value)) {
    processGapWarn.value = value.substring(0, value.length - 1);
  }
  if (!value.length) {
    processGapWarn.value = processGapWarn.value.replace(/(^0+)/, "");
  }
};
const onInputGapCaution = (value: any) => {
  const regExp = /^\d{0,1}(\.\d{0,2})?$/;
  if (!regExp.test(value)) {
    processGapCaution.value = value.substring(0, value.length - 1);
  }
  if (!value.length) {
    processGapCaution.value = processGapCaution.value.replace(/(^0+)/, "");
  }
};
const onInputBlur = () => {
  const regExp = /^\d{0,1}(\.\d{0,2})?$/;
  if (!regExp.test("" + processThickWarn.value)) {
    processThickWarn.value = "0";
  }
  if (!regExp.test("" + procesThickCaution.value)) {
    procesThickCaution.value = "0";
  }
  if (!regExp.test("" + processGapWarn.value)) {
    processGapWarn.value = "0";
  }
  if (!regExp.test("" + processGapCaution.value)) {
    processGapCaution.value = "0";
  }

  let split = processThickWarn.value.split(".");
  if (1 < split.length && 0 === split[1].length) {
    processThickWarn.value = "0";
  }
  split = procesThickCaution.value.split(".");
  if (1 < split.length && 0 === split[1].length) {
    procesThickCaution.value = "0";
  }
  split = processGapWarn.value.split(".");
  if (1 < split.length && 0 === split[1].length) {
    processGapWarn.value = "0";
  }
  split = processGapCaution.value.split(".");
  if (1 < split.length && 0 === split[1].length) {
    processGapCaution.value = "0";
  }

  if (!processThickWarn.value.length) {
    processThickWarn.value = "0";
  }
  if (!procesThickCaution.value.length) {
    procesThickCaution.value = "0";
  }
  if (!processGapWarn.value.length) {
    processGapWarn.value = "0";
  }
  if (!processGapCaution.value.length) {
    processGapCaution.value = "0";
  }

  onChange();
};

const onInputSize = (company: any) => {
  const regExp = /^\d{0,10}$/;
  if (!regExp.test(company.buildX)) {
    company.buildX = company.buildX.substring(0, company.buildX.length - 1);
  }
  if (!regExp.test(company.buildY)) {
    company.buildY = company.buildX.substring(0, company.buildY.length - 1);
  }
  if (!regExp.test(company.buildZ)) {
    company.buildZ = company.buildZ.substring(0, company.buildZ.length - 1);
  }
  company.buildX = company.buildX.replace(/(^0+)/, "");
  company.buildY = company.buildY.replace(/(^0+)/, "");
  company.buildZ = company.buildZ.replace(/(^0+)/, "");
};
const onInputBlurSize = (company: any) => {
  if (0 === company.buildX.length) {
    company.buildX = "0";
  }
  if (0 === company.buildY.length) {
    company.buildY = "0";
  }
  if (0 === company.buildZ.length) {
    company.buildZ = "0";
  }
};

const onInputPriceRatio = (company: any) => {
  company.costRate = company.costRate.replace(/[^0-9.]/g, "");
};
const onInputBlurPriceRatio = (company: any) => {
  if ("number" === typeof company.costRate) {
    return;
  }

  if (0 < company.costRate.length) {
    if ("." === company.costRate[0]) {
      company.costRate = "0" + company.costRate;
    }
  }
};

const numberComma = (src: string) => {
  const removeSrc = removeComma(src);

  const regExp = /^\d{0,10}$/;
  if (!regExp.test(removeSrc)) {
    return "";
  }

  if (removeSrc.length) {
    const ret = numberToComma(Number.parseInt(removeSrc));
    return ret;
  }

  return "";
};
const onInputNumber = (company: any) => {
  if (0 === company.minCost.length) {
    company.minCost = "0";
  }
  if (0 === company.useCost.length) {
    company.useCost = "0";
  }
  if (0 === company.materialCost.length) {
    company.materialCost = "0";
  }
};

const onAddMaterial = (e: any) => {
  if (1 >= e.target.value.length || 45 <= e.target.value.length) {
    toast.error("2자 이상 45자 이하로 입력해주세요.", {transition: toast.TRANSITIONS.SLIDE, position: toast.POSITION.TOP_CENTER});
    return;
  }

  companyStore.addMaterial(props.process.id, materialName.value);
  materialName.value = "";
};
const onAddCompany = (material: Material) => {
  companyStore.addCompany(props.process.id, material.id, material.companyName);
  material.companyName = "";
};

// Process
const onEditProcess = (e: MouseEvent) => {
  e.preventDefault();
  isShowContextProcess.value = true;
  optionsContext.value.x = e.x;
  optionsContext.value.y = e.y;
};
const onProcessUp = () => {
  companyStore.upProcess(props.process.rowIdx);
};
const onProcessDown = () => {
  companyStore.downProcess(props.process.rowIdx);
};
const onProcessDelete = () => {
  companyStore.removeProcess(props.process.id);
};

// Material
const onEditMaterial = (e: MouseEvent, material: Material) => {
  e.preventDefault();
  isShowContextMaterial.value = true;
  optionsContext.value.x = e.x;
  optionsContext.value.y = e.y;

  currentMaterial = material;
};
const onMaterialUp = () => {
  if (currentMaterial) {
    companyStore.upMaterial(props.process.id, currentMaterial.rowIdx);
  }
};
const onMaterialDown = () => {
  if (currentMaterial) {
    companyStore.downMaterial(props.process.id, currentMaterial.rowIdx);
  }
};
const onMaterialDelete = () => {
  if (currentMaterial) {
    companyStore.removeMaterial(props.process.id, currentMaterial.id);
  }
};

// Material
const onEditCompany = (e: MouseEvent, company: Company) => {
  e.preventDefault();
  isShowContextCompany.value = true;
  optionsContext.value.x = e.x;
  optionsContext.value.y = e.y;

  currentCompany = company;
};
const onCompanyUp = () => {
  if (currentCompany) {
    companyStore.upCompany(props.process.id, currentCompany.materialId, currentCompany.rowIdx);
  }
};
const onCompanyDown = () => {
  if (currentCompany) {
    companyStore.downCompany(props.process.id, currentCompany.materialId, currentCompany.rowIdx);
  }
};
const onCompanyDelete = () => {
  if (currentCompany) {
    companyStore.removeCompany(props.process.id, currentCompany.materialId, currentCompany.id);
  }
};

return (_ctx: any,_cache: any) => {
  const _component_context_menu_item = _resolveComponent("context-menu-item")!
  const _component_context_menu_sperator = _resolveComponent("context-menu-sperator")!
  const _component_context_menu_group = _resolveComponent("context-menu-group")!
  const _component_context_menu = _resolveComponent("context-menu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_context_menu, {
      show: _unref(isShowContextProcess),
      options: optionsContext.value
    }, {
      default: _withCtx(() => [
        _createVNode(_component_context_menu_item, {
          label: "올리기",
          onClick: onProcessUp
        }),
        _createVNode(_component_context_menu_item, {
          label: "내리기",
          onClick: onProcessDown
        }),
        _createVNode(_component_context_menu_sperator),
        _createVNode(_component_context_menu_item, {
          label: "삭제",
          onClick: onProcessDelete
        }),
        _createVNode(_component_context_menu_sperator),
        _createVNode(_component_context_menu_group, { label: "두께" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _withDirectives(_createElementVNode("input", {
                class: "w-10",
                type: "text",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(processThickWarn) ? (processThickWarn).value = $event : processThickWarn = $event)),
                onChange: onChange,
                onInput: _cache[1] || (_cache[1] = ($event: any) => (onInputTickWarn(_unref(processThickWarn)))),
                onBlur: onInputBlur
              }, null, 544), [
                [_vModelText, _unref(processThickWarn)]
              ])
            ]),
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _withDirectives(_createElementVNode("input", {
                class: "w-10",
                type: "text",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(procesThickCaution) ? (procesThickCaution).value = $event : procesThickCaution = $event)),
                onChange: onChange,
                onInput: _cache[3] || (_cache[3] = ($event: any) => (onInputTickCaution(_unref(procesThickCaution)))),
                onBlur: onInputBlur
              }, null, 544), [
                [_vModelText, _unref(procesThickCaution)]
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_context_menu_group, { label: "뭉개짐" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _withDirectives(_createElementVNode("input", {
                class: "w-10",
                type: "text",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(processGapWarn) ? (processGapWarn).value = $event : processGapWarn = $event)),
                onChange: onChange,
                onInput: _cache[5] || (_cache[5] = ($event: any) => (onInputGapWarn(_unref(processGapWarn)))),
                onBlur: onInputBlur
              }, null, 544), [
                [_vModelText, _unref(processGapWarn)]
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _withDirectives(_createElementVNode("input", {
                class: "w-10",
                type: "text",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_isRef(processGapCaution) ? (processGapCaution).value = $event : processGapCaution = $event)),
                onChange: onChange,
                onInput: _cache[7] || (_cache[7] = ($event: any) => (onInputGapCaution(_unref(processGapCaution)))),
                onBlur: onInputBlur
              }, null, 544), [
                [_vModelText, _unref(processGapCaution)]
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["show", "options"]),
    _createVNode(_component_context_menu, {
      show: _unref(isShowContextMaterial),
      options: optionsContext.value
    }, {
      default: _withCtx(() => [
        _createVNode(_component_context_menu_item, {
          label: "올리기",
          onClick: onMaterialUp
        }),
        _createVNode(_component_context_menu_item, {
          label: "내리기",
          onClick: onMaterialDown
        }),
        _createVNode(_component_context_menu_sperator),
        _createVNode(_component_context_menu_item, {
          label: "삭제",
          onClick: onMaterialDelete
        })
      ]),
      _: 1
    }, 8, ["show", "options"]),
    _createVNode(_component_context_menu, {
      show: _unref(isShowContextCompany),
      options: optionsContext.value
    }, {
      default: _withCtx(() => [
        _createVNode(_component_context_menu_item, {
          label: "올리기",
          onClick: onCompanyUp
        }),
        _createVNode(_component_context_menu_item, {
          label: "내리기",
          onClick: onCompanyDown
        }),
        _createVNode(_component_context_menu_sperator),
        _createVNode(_component_context_menu_item, {
          label: "삭제",
          onClick: onCompanyDelete
        })
      ]),
      _: 1
    }, 8, ["show", "options"]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("button", { onClick: onEditProcess }, _hoisted_13),
          _createElementVNode("div", _hoisted_14, [
            _withDirectives(_createElementVNode("input", {
              class: "",
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_isRef(processName) ? (processName).value = $event : processName = $event)),
              type: "text",
              placeholder: "",
              onChange: onChange
            }, null, 544), [
              [_vModelText, _unref(processName)]
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_15, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.process.matarials, (material) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "flex border-b border-line",
          key: material.id
        }, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("button", {
                onClick: ($event: any) => (onEditMaterial($event, material))
              }, _hoisted_20, 8, _hoisted_18),
              _createElementVNode("div", _hoisted_21, [
                _withDirectives(_createElementVNode("input", {
                  class: "",
                  "onUpdate:modelValue": ($event: any) => ((material.name) = $event),
                  type: "text",
                  placeholder: ""
                }, null, 8, _hoisted_22), [
                  [_vModelText, material.name]
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_23, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(material.companys, (company) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "flex border-b border-line",
                key: company.id
              }, [
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("button", {
                      onClick: ($event: any) => (onEditCompany($event, company))
                    }, _hoisted_28, 8, _hoisted_26),
                    _createElementVNode("div", _hoisted_29, [
                      _withDirectives(_createElementVNode("input", {
                        class: "",
                        "onUpdate:modelValue": ($event: any) => ((company.name) = $event),
                        type: "text",
                        placeholder: ""
                      }, null, 8, _hoisted_30), [
                        [_vModelText, company.name]
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("div", _hoisted_32, [
                    _withDirectives(_createElementVNode("input", {
                      class: "",
                      "onUpdate:modelValue": ($event: any) => ((company.printer) = $event),
                      type: "text",
                      placeholder: ""
                    }, null, 8, _hoisted_33), [
                      [_vModelText, company.printer]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("div", _hoisted_35, [
                    _withDirectives(_createElementVNode("input", {
                      class: "",
                      "onUpdate:modelValue": ($event: any) => ((company.buildX) = $event),
                      type: "text",
                      placeholder: "",
                      onInput: ($event: any) => (onInputSize(company)),
                      onBlur: ($event: any) => (onInputBlurSize(company))
                    }, null, 40, _hoisted_36), [
                      [_vModelText, company.buildX]
                    ])
                  ]),
                  _hoisted_37,
                  _createElementVNode("div", _hoisted_38, [
                    _withDirectives(_createElementVNode("input", {
                      class: "",
                      "onUpdate:modelValue": ($event: any) => ((company.buildY) = $event),
                      type: "text",
                      placeholder: "",
                      onInput: ($event: any) => (onInputSize(company)),
                      onBlur: ($event: any) => (onInputBlurSize(company))
                    }, null, 40, _hoisted_39), [
                      [_vModelText, company.buildY]
                    ])
                  ]),
                  _hoisted_40,
                  _createElementVNode("div", _hoisted_41, [
                    _withDirectives(_createElementVNode("input", {
                      class: "",
                      "onUpdate:modelValue": ($event: any) => ((company.buildZ) = $event),
                      type: "text",
                      placeholder: "",
                      onInput: ($event: any) => (onInputSize(company)),
                      onBlur: ($event: any) => (onInputBlurSize(company))
                    }, null, 40, _hoisted_42), [
                      [_vModelText, company.buildZ]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_43, [
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input m-auto",
                    id: "term",
                    type: "checkbox",
                    checked: company.isPaint,
                    "onUpdate:modelValue": ($event: any) => ((company.isPaint) = $event)
                  }, null, 8, _hoisted_44), [
                    [_vModelCheckbox, company.isPaint]
                  ])
                ]),
                _createElementVNode("div", _hoisted_45, [
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input m-auto",
                    id: "term",
                    type: "checkbox",
                    checked: company.isPostProcess,
                    "onUpdate:modelValue": ($event: any) => ((company.isPostProcess) = $event)
                  }, null, 8, _hoisted_46), [
                    [_vModelCheckbox, company.isPostProcess]
                  ])
                ]),
                _createElementVNode("div", _hoisted_47, [
                  _createElementVNode("div", _hoisted_48, [
                    _withDirectives(_createElementVNode("input", {
                      class: "text-right",
                      "onUpdate:modelValue": ($event: any) => ((company.costRate) = $event),
                      type: "text",
                      placeholder: "",
                      onInput: ($event: any) => (onInputPriceRatio(company)),
                      onBlur: ($event: any) => (onInputBlurPriceRatio(company))
                    }, null, 40, _hoisted_49), [
                      [_vModelText, company.costRate]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_50, [
                  _createElementVNode("div", _hoisted_51, [
                    _withDirectives(_createElementVNode("input", {
                      class: "text-right",
                      "onUpdate:modelValue": ($event: any) => ((company.minCost) = $event),
                      type: "text",
                      placeholder: "",
                      onKeyup: ($event: any) => (company.minCost = numberComma(company.minCost)),
                      onBlur: ($event: any) => (onInputNumber(company))
                    }, null, 40, _hoisted_52), [
                      [_vModelText, company.minCost]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_53, [
                  _createElementVNode("div", _hoisted_54, [
                    _withDirectives(_createElementVNode("input", {
                      class: "text-right",
                      "onUpdate:modelValue": ($event: any) => ((company.useCost) = $event),
                      type: "text",
                      placeholder: "",
                      onKeyup: ($event: any) => (company.useCost = numberComma(company.useCost)),
                      onBlur: ($event: any) => (onInputNumber(company))
                    }, null, 40, _hoisted_55), [
                      [_vModelText, company.useCost]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_56, [
                  _createElementVNode("div", _hoisted_57, [
                    _withDirectives(_createElementVNode("input", {
                      class: "text-right",
                      "onUpdate:modelValue": ($event: any) => ((company.materialCost) = $event),
                      type: "text",
                      placeholder: "",
                      onKeyup: ($event: any) => (company.materialCost = numberComma(company.materialCost)),
                      onBlur: ($event: any) => (onInputNumber(company))
                    }, null, 40, _hoisted_58), [
                      [_vModelText, company.materialCost]
                    ])
                  ])
                ])
              ]))
            }), 128)),
            _createElementVNode("div", _hoisted_59, [
              _createElementVNode("div", _hoisted_60, [
                _createElementVNode("div", _hoisted_61, [
                  _withDirectives(_createElementVNode("input", {
                    class: "",
                    "onUpdate:modelValue": ($event: any) => ((material.companyName) = $event),
                    type: "text",
                    placeholder: "",
                    onKeypress: _withKeys(($event: any) => (onAddCompany(material)), ["enter"])
                  }, null, 40, _hoisted_62), [
                    [_vModelText, material.companyName]
                  ])
                ])
              ]),
              _hoisted_63
            ])
          ])
        ]))
      }), 128)),
      _createElementVNode("div", _hoisted_64, [
        _createElementVNode("div", _hoisted_65, [
          _createElementVNode("div", _hoisted_66, [
            _withDirectives(_createElementVNode("input", {
              class: "",
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_isRef(materialName) ? (materialName).value = $event : materialName = $event)),
              type: "text",
              placeholder: "",
              onKeypress: _withKeys(onAddMaterial, ["enter"])
            }, null, 40, _hoisted_67), [
              [_vModelText, _unref(materialName)]
            ])
          ])
        ]),
        _hoisted_68
      ])
    ])
  ]))
}
}

})